export default __webpack_public_path__ + "static/media/headerd.427bda45.jpg";